<template>
	<MStateBox :loading="isLoading" :empty="isEmpty">
		<div class="wrapper-box">
			<RowInfoLink
				v-for="(item, index) in currentData"
				:key="index"
				:sort="index + 1"
				:item="item"
				:border="index != currentData.length - 1"
				@click="goDetail(item)"
			>
				<div slot="more" class="box-more">
					<span>{{ $t('enterprise.view-details') }}</span>
					<i class="iconfont icon-flip-right"></i>
				</div>
			</RowInfoLink>
		</div>
	</MStateBox>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useCurrentContext } from './context';
import RowInfoLink from '@/views/home/components/RowInfoLink.vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import dayjs from 'dayjs';

const { announcement } = useModuleData();
const { viewModule } = useModuleNavigation();

const context = useCurrentContext();
const languageType = computed(() => context.languageType);

const goDetail = item => {
	viewModule('announcement', item);
};

const currentData = computed(() => {
	const data = announcement.data?.rows || [];
	return data.slice(0, 3).map(item => ({
		...item,
		time: dayjs(item.publishDate).valueOf()
	}));
});

const isLoading = computed(() => announcement.loading);
const isEmpty = computed(() => announcement.empty || !currentData.value.length);

const loadData = async () => {
	await announcement.refresh({
		useStockCode: true,  // flow模板使用股票代码API
		pageNum: 20,
		pageStart: 0,
		order: 'desc',
		isPublish: true,
		...languageType.value
	});
};

onMounted(() => {
	loadData();
});


</script>

<style lang="less" scoped>
.wrapper-box {
	.box-more {
		display: flex;
		align-items: center;
		cursor: pointer;

		span {
			color: #86909c;
			text-align: right;
			font-size: 14px;
			font-weight: 400;
			line-height: 16px;
		}
		.iconfont {
			font-size: 16px;
			color: #86909c;
		}
	}
}
</style> 